import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

const resources = {
  fr: {
    translation: {
      // Navigation
      "nav.home": "Accueil",
      "nav.explore": "Explorer",
      "nav.dashboard": "Dashboard",
      "nav.profile": "Profil",
      "nav.login": "Connexion",
      "nav.register": "Inscription",
      "nav.logout": "Déconnexion",
      
      // Hero
      "hero.title": "Vivez une expérience authentique",
      "hero.subtitle": "Laissez-vous guider par des locaux passionnés pour découvrir des lieux insoupçonnés",
      "hero.cta": "Commencer l'aventure",
      "hero.search_placeholder": "Où souhaitez-vous aller ?",
      
      // Home
      "home.categories": "Explorez par catégorie",
      "home.featured": "Expériences populaires",
      "home.explorers": "Nos explorateurs",
      "home.how_it_works": "Comment ça marche",
      "home.step1_title": "Choisissez votre destination",
      "home.step1_desc": "Parcourez nos expériences uniques dans le monde entier",
      "home.step2_title": "Connectez-vous avec un explorateur",
      "home.step2_desc": "Échangez avec un local passionné qui connaît sa région",
      "home.step3_title": "Vivez l'aventure",
      "home.step3_desc": "Laissez-vous guider et créez des souvenirs inoubliables",
      
      // Categories
      "category.adventure": "Aventure & Nature",
      "category.fun": "Fun",
      "category.food": "Gastronomie",
      "category.culture": "Culture & Histoire",
      "category.sport": "Sport",
      "category.healing": "Healing & Retraite",
      "category.nightlife": "Vie nocturne",
      "category.vanlife": "Vanlife",
      "category.artisanat": "Artisanat",
      "category.local_events": "Événements locaux",
      
      // Auth
      "auth.login_title": "Bienvenue",
      "auth.login_subtitle": "Connectez-vous pour continuer votre aventure",
      "auth.register_title": "Rejoignez XPerience",
      "auth.register_subtitle": "Créez votre compte et commencez l'aventure",
      "auth.email": "Email",
      "auth.password": "Mot de passe",
      "auth.forgot_password": "Mot de passe oublié ?",
      "auth.name": "Nom complet",
      "auth.role": "Je suis...",
      "auth.role_explorer": "Explorateur (guide local)",
      "auth.role_experimenter": "Expérimentateur (voyageur)",
      "auth.login_btn": "Se connecter",
      "auth.register_btn": "Créer mon compte",
      "auth.or": "ou",
      "auth.google": "Continuer avec Google",
      "auth.no_account": "Pas encore de compte ?",
      "auth.has_account": "Déjà un compte ?",
      
      // Experience
      "exp.from": "À partir de",
      "exp.per_person": "/ personne",
      "exp.duration": "Durée",
      "exp.hours": "heures",
      "exp.participants": "Max participants",
      "exp.includes_vehicle": "Véhicule inclus",
      "exp.includes_accommodation": "Hébergement inclus",
      "exp.book_now": "Réserver",
      "exp.reviews": "avis",
      "exp.about_explorer": "À propos de l'explorateur",
      "exp.select_date": "Sélectionnez une date",
      "exp.select_participants": "Nombre de participants",
      "exp.add_vehicle": "Ajouter véhicule",
      "exp.add_accommodation": "Ajouter hébergement",
      "exp.total": "Total",
      "exp.message": "Message pour l'explorateur (optionnel)",
      
      // Booking
      "booking.title": "Réservation",
      "booking.summary": "Récapitulatif",
      "booking.base_price": "Prix de base",
      "booking.vehicle": "Véhicule",
      "booking.accommodation": "Hébergement",
      "booking.platform_fee": "Frais de service",
      "booking.total": "Total à payer",
      "booking.pay": "Payer maintenant",
      "booking.status.pending": "En attente",
      "booking.status.confirmed": "Confirmée",
      "booking.status.completed": "Terminée",
      "booking.status.cancelled": "Annulée",
      
      // Dashboard
      "dashboard.title": "Tableau de bord",
      "dashboard.my_experiences": "Mes expériences",
      "dashboard.my_bookings": "Mes réservations",
      "dashboard.my_reviews": "Mes avis",
      "dashboard.create_experience": "Créer une expérience",
      "dashboard.earnings": "Revenus",
      "dashboard.total_bookings": "Réservations",
      "dashboard.rating": "Note moyenne",
      "dashboard.trips": "Voyages effectués",
      
      // Common
      "common.search": "Rechercher",
      "common.filter": "Filtrer",
      "common.sort": "Trier",
      "common.loading": "Chargement...",
      "common.error": "Une erreur est survenue",
      "common.save": "Enregistrer",
      "common.cancel": "Annuler",
      "common.confirm": "Confirmer",
      "common.delete": "Supprimer",
      "common.edit": "Modifier",
      "common.view": "Voir",
      "common.back": "Retour",
      "common.next": "Suivant",
      "common.previous": "Précédent",
      "common.success": "Succès",
      
      // Footer
      "footer.tagline": "Voyagez autrement, rencontrez vraiment.",
      "footer.company": "Entreprise",
      "footer.about": "À propos",
      "footer.careers": "Carrières",
      "footer.press": "Presse",
      "footer.support": "Support",
      "footer.help": "Centre d'aide",
      "footer.contact": "Contact",
      "footer.terms": "Conditions",
      "footer.privacy": "Confidentialité",
      "footer.legal": "Légal",
      "footer.copyright": "© 2026 XPerience. Tous droits réservés.",
      "footer.creator": "Créé par Steve Rosset"
    }
  },
  en: {
    translation: {
      "nav.home": "Home",
      "nav.explore": "Explore",
      "nav.dashboard": "Dashboard",
      "nav.profile": "Profile",
      "nav.login": "Login",
      "nav.register": "Register",
      "nav.logout": "Logout",
      "hero.title": "Live an authentic experience",
      "hero.subtitle": "Let passionate locals guide you to discover hidden gems",
      "hero.cta": "Start the adventure",
      "hero.search_placeholder": "Where do you want to go?",
      "home.categories": "Explore by category",
      "home.featured": "Popular experiences",
      "home.explorers": "Our explorers",
      "home.how_it_works": "How it works",
      "home.step1_title": "Choose your destination",
      "home.step1_desc": "Browse our unique experiences around the world",
      "home.step2_title": "Connect with an explorer",
      "home.step2_desc": "Chat with a passionate local who knows their region",
      "home.step3_title": "Live the adventure",
      "home.step3_desc": "Let yourself be guided and create unforgettable memories",
      "category.adventure": "Adventure & Nature",
      "category.fun": "Fun Activities",
      "category.food": "Food & Culinary",
      "category.culture": "Culture & History",
      "category.sport": "Sports",
      "category.healing": "Healing & Retreat",
      "category.nightlife": "Nightlife",
      "category.vanlife": "Vanlife",
      "category.artisanat": "Crafts",
      "category.local_events": "Local Events",
      "auth.login_title": "Welcome back",
      "auth.login_subtitle": "Login to continue your adventure",
      "auth.register_title": "Join XPerience",
      "auth.register_subtitle": "Create your account and start the adventure",
      "auth.email": "Email",
      "auth.password": "Password",
      "auth.forgot_password": "Forgot password?",
      "auth.name": "Full name",
      "auth.role": "I am a...",
      "auth.role_explorer": "Explorer (local guide)",
      "auth.role_experimenter": "Experimenter (traveler)",
      "auth.login_btn": "Login",
      "auth.register_btn": "Create account",
      "auth.or": "or",
      "auth.google": "Continue with Google",
      "auth.no_account": "Don't have an account?",
      "auth.has_account": "Already have an account?",
      "exp.from": "From",
      "exp.per_person": "/ person",
      "exp.duration": "Duration",
      "exp.hours": "hours",
      "exp.participants": "Max participants",
      "exp.includes_vehicle": "Vehicle included",
      "exp.includes_accommodation": "Accommodation included",
      "exp.book_now": "Book now",
      "exp.reviews": "reviews",
      "exp.about_explorer": "About the explorer",
      "exp.select_date": "Select a date",
      "exp.select_participants": "Number of participants",
      "exp.add_vehicle": "Add vehicle",
      "exp.add_accommodation": "Add accommodation",
      "exp.total": "Total",
      "exp.message": "Message for the explorer (optional)",
      "booking.title": "Booking",
      "booking.summary": "Summary",
      "booking.base_price": "Base price",
      "booking.vehicle": "Vehicle",
      "booking.accommodation": "Accommodation",
      "booking.platform_fee": "Service fee",
      "booking.total": "Total to pay",
      "booking.pay": "Pay now",
      "booking.status.pending": "Pending",
      "booking.status.confirmed": "Confirmed",
      "booking.status.completed": "Completed",
      "booking.status.cancelled": "Cancelled",
      "dashboard.title": "Dashboard",
      "dashboard.my_experiences": "My experiences",
      "dashboard.my_bookings": "My bookings",
      "dashboard.my_reviews": "My reviews",
      "dashboard.create_experience": "Create experience",
      "dashboard.earnings": "Earnings",
      "dashboard.total_bookings": "Bookings",
      "dashboard.rating": "Average rating",
      "dashboard.trips": "Trips completed",
      "common.search": "Search",
      "common.filter": "Filter",
      "common.sort": "Sort",
      "common.loading": "Loading...",
      "common.error": "An error occurred",
      "common.save": "Save",
      "common.cancel": "Cancel",
      "common.confirm": "Confirm",
      "common.delete": "Delete",
      "common.edit": "Edit",
      "common.view": "View",
      "common.back": "Back",
      "common.next": "Next",
      "common.previous": "Previous",
      "common.success": "Success",
      "footer.tagline": "Travel differently, meet truly.",
      "footer.company": "Company",
      "footer.about": "About",
      "footer.careers": "Careers",
      "footer.press": "Press",
      "footer.support": "Support",
      "footer.help": "Help Center",
      "footer.contact": "Contact",
      "footer.terms": "Terms",
      "footer.privacy": "Privacy",
      "footer.legal": "Legal",
      "footer.copyright": "© 2026 XPerience. All rights reserved.",
      "footer.creator": "Created by Steve Rosset"
    }
  },
  es: {
    translation: {
      "nav.home": "Inicio",
      "nav.explore": "Explorar",
      "nav.dashboard": "Panel",
      "nav.profile": "Perfil",
      "nav.login": "Iniciar sesión",
      "nav.register": "Registrarse",
      "nav.logout": "Cerrar sesión",
      "hero.title": "Vive una experiencia auténtica",
      "hero.subtitle": "Déjate guiar por locales apasionados para descubrir lugares ocultos",
      "hero.cta": "Comienza la aventura",
      "hero.search_placeholder": "¿A dónde quieres ir?",
      "home.categories": "Explora por categoría",
      "home.featured": "Experiencias populares",
      "home.explorers": "Nuestros exploradores",
      "home.how_it_works": "Cómo funciona",
      "home.step1_title": "Elige tu destino",
      "home.step1_desc": "Explora nuestras experiencias únicas en todo el mundo",
      "home.step2_title": "Conecta con un explorador",
      "home.step2_desc": "Habla con un local apasionado que conoce su región",
      "home.step3_title": "Vive la aventura",
      "home.step3_desc": "Déjate guiar y crea recuerdos inolvidables",
      "category.adventure": "Aventura y Naturaleza",
      "category.fun": "Diversión",
      "category.food": "Gastronomía",
      "category.culture": "Cultura e Historia",
      "category.sport": "Deportes",
      "category.healing": "Bienestar y Retiro",
      "category.nightlife": "Vida nocturna",
      "category.vanlife": "Vanlife",
      "category.artisanat": "Artesanía",
      "category.local_events": "Eventos locales",
      "auth.login_title": "Bienvenido de nuevo",
      "auth.login_subtitle": "Inicia sesión para continuar tu aventura",
      "auth.register_title": "Únete a XPerience",
      "auth.register_subtitle": "Crea tu cuenta y comienza la aventura",
      "auth.email": "Correo electrónico",
      "auth.password": "Contraseña",
      "auth.name": "Nombre completo",
      "auth.role": "Soy...",
      "auth.role_explorer": "Explorador (guía local)",
      "auth.role_experimenter": "Experimentador (viajero)",
      "auth.login_btn": "Iniciar sesión",
      "auth.register_btn": "Crear cuenta",
      "auth.or": "o",
      "auth.google": "Continuar con Google",
      "auth.no_account": "¿No tienes cuenta?",
      "auth.has_account": "¿Ya tienes cuenta?",
      "exp.from": "Desde",
      "exp.per_person": "/ persona",
      "exp.duration": "Duración",
      "exp.hours": "horas",
      "exp.participants": "Máx. participantes",
      "exp.includes_vehicle": "Vehículo incluido",
      "exp.includes_accommodation": "Alojamiento incluido",
      "exp.book_now": "Reservar",
      "exp.reviews": "opiniones",
      "exp.about_explorer": "Sobre el explorador",
      "exp.select_date": "Selecciona una fecha",
      "exp.select_participants": "Número de participantes",
      "exp.add_vehicle": "Añadir vehículo",
      "exp.add_accommodation": "Añadir alojamiento",
      "exp.total": "Total",
      "exp.message": "Mensaje para el explorador (opcional)",
      "booking.title": "Reserva",
      "booking.summary": "Resumen",
      "booking.base_price": "Precio base",
      "booking.vehicle": "Vehículo",
      "booking.accommodation": "Alojamiento",
      "booking.platform_fee": "Tarifa de servicio",
      "booking.total": "Total a pagar",
      "booking.pay": "Pagar ahora",
      "booking.status.pending": "Pendiente",
      "booking.status.confirmed": "Confirmada",
      "booking.status.completed": "Completada",
      "booking.status.cancelled": "Cancelada",
      "dashboard.title": "Panel de control",
      "dashboard.my_experiences": "Mis experiencias",
      "dashboard.my_bookings": "Mis reservas",
      "dashboard.my_reviews": "Mis opiniones",
      "dashboard.create_experience": "Crear experiencia",
      "dashboard.earnings": "Ingresos",
      "dashboard.total_bookings": "Reservas",
      "dashboard.rating": "Valoración media",
      "dashboard.trips": "Viajes realizados",
      "common.search": "Buscar",
      "common.filter": "Filtrar",
      "common.sort": "Ordenar",
      "common.loading": "Cargando...",
      "common.error": "Ha ocurrido un error",
      "common.save": "Guardar",
      "common.cancel": "Cancelar",
      "common.confirm": "Confirmar",
      "common.delete": "Eliminar",
      "common.edit": "Editar",
      "common.view": "Ver",
      "common.back": "Volver",
      "common.next": "Siguiente",
      "common.previous": "Anterior",
      "common.success": "Éxito",
      "footer.tagline": "Viaja diferente, conoce de verdad.",
      "footer.company": "Empresa",
      "footer.about": "Sobre nosotros",
      "footer.careers": "Empleo",
      "footer.press": "Prensa",
      "footer.support": "Soporte",
      "footer.help": "Centro de ayuda",
      "footer.contact": "Contacto",
      "footer.terms": "Términos",
      "footer.privacy": "Privacidad",
      "footer.legal": "Legal",
      "footer.copyright": "© 2026 XPerience. Todos los derechos reservados.",
      "footer.creator": "Creado por Steve Rosset"
    }
  },
  it: {
    translation: {
      "nav.home": "Home",
      "nav.explore": "Esplora",
      "nav.dashboard": "Dashboard",
      "nav.profile": "Profilo",
      "nav.login": "Accedi",
      "nav.register": "Registrati",
      "nav.logout": "Esci",
      "hero.title": "Vivi un'esperienza autentica",
      "hero.subtitle": "Lasciati guidare da locali appassionati per scoprire luoghi nascosti",
      "hero.cta": "Inizia l'avventura",
      "hero.search_placeholder": "Dove vuoi andare?",
      "home.categories": "Esplora per categoria",
      "home.featured": "Esperienze popolari",
      "home.explorers": "I nostri esploratori",
      "home.how_it_works": "Come funziona",
      "home.step1_title": "Scegli la tua destinazione",
      "home.step1_desc": "Sfoglia le nostre esperienze uniche in tutto il mondo",
      "home.step2_title": "Connettiti con un esploratore",
      "home.step2_desc": "Parla con un locale appassionato che conosce la sua regione",
      "home.step3_title": "Vivi l'avventura",
      "home.step3_desc": "Lasciati guidare e crea ricordi indimenticabili",
      "category.adventure": "Avventura e Natura",
      "category.fun": "Divertimento",
      "category.food": "Gastronomia",
      "category.culture": "Cultura e Storia",
      "category.sport": "Sport",
      "category.healing": "Benessere e Ritiro",
      "category.nightlife": "Vita notturna",
      "category.vanlife": "Vanlife",
      "category.artisanat": "Artigianato",
      "category.local_events": "Eventi locali",
      "auth.login_title": "Bentornato",
      "auth.login_subtitle": "Accedi per continuare la tua avventura",
      "auth.register_title": "Unisciti a XPerience",
      "auth.register_subtitle": "Crea il tuo account e inizia l'avventura",
      "auth.email": "Email",
      "auth.password": "Password",
      "auth.name": "Nome completo",
      "auth.role": "Sono un...",
      "auth.role_explorer": "Esploratore (guida locale)",
      "auth.role_experimenter": "Sperimentatore (viaggiatore)",
      "auth.login_btn": "Accedi",
      "auth.register_btn": "Crea account",
      "auth.or": "oppure",
      "auth.google": "Continua con Google",
      "auth.no_account": "Non hai un account?",
      "auth.has_account": "Hai già un account?",
      "exp.from": "Da",
      "exp.per_person": "/ persona",
      "exp.duration": "Durata",
      "exp.hours": "ore",
      "exp.participants": "Max partecipanti",
      "exp.includes_vehicle": "Veicolo incluso",
      "exp.includes_accommodation": "Alloggio incluso",
      "exp.book_now": "Prenota ora",
      "exp.reviews": "recensioni",
      "exp.about_explorer": "Informazioni sull'esploratore",
      "exp.select_date": "Seleziona una data",
      "exp.select_participants": "Numero di partecipanti",
      "exp.add_vehicle": "Aggiungi veicolo",
      "exp.add_accommodation": "Aggiungi alloggio",
      "exp.total": "Totale",
      "exp.message": "Messaggio per l'esploratore (opzionale)",
      "booking.title": "Prenotazione",
      "booking.summary": "Riepilogo",
      "booking.base_price": "Prezzo base",
      "booking.vehicle": "Veicolo",
      "booking.accommodation": "Alloggio",
      "booking.platform_fee": "Commissione servizio",
      "booking.total": "Totale da pagare",
      "booking.pay": "Paga ora",
      "booking.status.pending": "In attesa",
      "booking.status.confirmed": "Confermata",
      "booking.status.completed": "Completata",
      "booking.status.cancelled": "Cancellata",
      "dashboard.title": "Dashboard",
      "dashboard.my_experiences": "Le mie esperienze",
      "dashboard.my_bookings": "Le mie prenotazioni",
      "dashboard.my_reviews": "Le mie recensioni",
      "dashboard.create_experience": "Crea esperienza",
      "dashboard.earnings": "Guadagni",
      "dashboard.total_bookings": "Prenotazioni",
      "dashboard.rating": "Valutazione media",
      "dashboard.trips": "Viaggi completati",
      "common.search": "Cerca",
      "common.filter": "Filtra",
      "common.sort": "Ordina",
      "common.loading": "Caricamento...",
      "common.error": "Si è verificato un errore",
      "common.save": "Salva",
      "common.cancel": "Annulla",
      "common.confirm": "Conferma",
      "common.delete": "Elimina",
      "common.edit": "Modifica",
      "common.view": "Visualizza",
      "common.back": "Indietro",
      "common.next": "Avanti",
      "common.previous": "Precedente",
      "common.success": "Successo",
      "footer.tagline": "Viaggia diversamente, incontra davvero.",
      "footer.company": "Azienda",
      "footer.about": "Chi siamo",
      "footer.careers": "Lavora con noi",
      "footer.press": "Stampa",
      "footer.support": "Supporto",
      "footer.help": "Centro assistenza",
      "footer.contact": "Contatti",
      "footer.terms": "Termini",
      "footer.privacy": "Privacy",
      "footer.legal": "Note legali",
      "footer.copyright": "© 2026 XPerience. Tutti i diritti riservati.",
      "footer.creator": "Creato da Steve Rosset"
    }
  },
  de: {
    translation: {
      "nav.home": "Startseite",
      "nav.explore": "Entdecken",
      "nav.dashboard": "Dashboard",
      "nav.profile": "Profil",
      "nav.login": "Anmelden",
      "nav.register": "Registrieren",
      "nav.logout": "Abmelden",
      "hero.title": "Erlebe ein authentisches Erlebnis",
      "hero.subtitle": "Lass dich von leidenschaftlichen Einheimischen zu verborgenen Orten führen",
      "hero.cta": "Starte das Abenteuer",
      "hero.search_placeholder": "Wohin möchtest du gehen?",
      "home.categories": "Nach Kategorie erkunden",
      "home.featured": "Beliebte Erlebnisse",
      "home.explorers": "Unsere Entdecker",
      "home.how_it_works": "So funktioniert's",
      "home.step1_title": "Wähle dein Ziel",
      "home.step1_desc": "Durchstöbere unsere einzigartigen Erlebnisse weltweit",
      "home.step2_title": "Verbinde dich mit einem Entdecker",
      "home.step2_desc": "Chatte mit einem leidenschaftlichen Einheimischen, der seine Region kennt",
      "home.step3_title": "Erlebe das Abenteuer",
      "home.step3_desc": "Lass dich führen und schaffe unvergessliche Erinnerungen",
      "category.adventure": "Abenteuer & Natur",
      "category.fun": "Spaß",
      "category.food": "Gastronomie",
      "category.culture": "Kultur & Geschichte",
      "category.sport": "Sport",
      "category.healing": "Wellness & Retreat",
      "category.nightlife": "Nachtleben",
      "category.vanlife": "Vanlife",
      "category.artisanat": "Handwerk",
      "category.local_events": "Lokale Veranstaltungen",
      "auth.login_title": "Willkommen zurück",
      "auth.login_subtitle": "Melde dich an, um dein Abenteuer fortzusetzen",
      "auth.register_title": "Werde Teil von XPerience",
      "auth.register_subtitle": "Erstelle dein Konto und starte das Abenteuer",
      "auth.email": "E-Mail",
      "auth.password": "Passwort",
      "auth.name": "Vollständiger Name",
      "auth.role": "Ich bin...",
      "auth.role_explorer": "Entdecker (lokaler Guide)",
      "auth.role_experimenter": "Experimentierer (Reisender)",
      "auth.login_btn": "Anmelden",
      "auth.register_btn": "Konto erstellen",
      "auth.or": "oder",
      "auth.google": "Mit Google fortfahren",
      "auth.no_account": "Noch kein Konto?",
      "auth.has_account": "Bereits ein Konto?",
      "exp.from": "Ab",
      "exp.per_person": "/ Person",
      "exp.duration": "Dauer",
      "exp.hours": "Stunden",
      "exp.participants": "Max. Teilnehmer",
      "exp.includes_vehicle": "Fahrzeug inklusive",
      "exp.includes_accommodation": "Unterkunft inklusive",
      "exp.book_now": "Jetzt buchen",
      "exp.reviews": "Bewertungen",
      "exp.about_explorer": "Über den Entdecker",
      "exp.select_date": "Datum auswählen",
      "exp.select_participants": "Anzahl der Teilnehmer",
      "exp.add_vehicle": "Fahrzeug hinzufügen",
      "exp.add_accommodation": "Unterkunft hinzufügen",
      "exp.total": "Gesamt",
      "exp.message": "Nachricht an den Entdecker (optional)",
      "booking.title": "Buchung",
      "booking.summary": "Zusammenfassung",
      "booking.base_price": "Grundpreis",
      "booking.vehicle": "Fahrzeug",
      "booking.accommodation": "Unterkunft",
      "booking.platform_fee": "Servicegebühr",
      "booking.total": "Gesamtbetrag",
      "booking.pay": "Jetzt bezahlen",
      "booking.status.pending": "Ausstehend",
      "booking.status.confirmed": "Bestätigt",
      "booking.status.completed": "Abgeschlossen",
      "booking.status.cancelled": "Storniert",
      "dashboard.title": "Dashboard",
      "dashboard.my_experiences": "Meine Erlebnisse",
      "dashboard.my_bookings": "Meine Buchungen",
      "dashboard.my_reviews": "Meine Bewertungen",
      "dashboard.create_experience": "Erlebnis erstellen",
      "dashboard.earnings": "Einnahmen",
      "dashboard.total_bookings": "Buchungen",
      "dashboard.rating": "Durchschnittsbewertung",
      "dashboard.trips": "Abgeschlossene Reisen",
      "common.search": "Suchen",
      "common.filter": "Filtern",
      "common.sort": "Sortieren",
      "common.loading": "Laden...",
      "common.error": "Ein Fehler ist aufgetreten",
      "common.save": "Speichern",
      "common.cancel": "Abbrechen",
      "common.confirm": "Bestätigen",
      "common.delete": "Löschen",
      "common.edit": "Bearbeiten",
      "common.view": "Ansehen",
      "common.back": "Zurück",
      "common.next": "Weiter",
      "common.previous": "Zurück",
      "common.success": "Erfolg",
      "footer.tagline": "Anders reisen, wirklich begegnen.",
      "footer.company": "Unternehmen",
      "footer.about": "Über uns",
      "footer.careers": "Karriere",
      "footer.press": "Presse",
      "footer.support": "Support",
      "footer.help": "Hilfe-Center",
      "footer.contact": "Kontakt",
      "footer.terms": "AGB",
      "footer.privacy": "Datenschutz",
      "footer.legal": "Impressum",
      "footer.copyright": "© 2026 XPerience. Alle Rechte vorbehalten.",
      "footer.creator": "Erstellt von Steve Rosset"
    }
  },
  pt: {
    translation: {
      "nav.home": "Início",
      "nav.explore": "Explorar",
      "nav.dashboard": "Painel",
      "nav.profile": "Perfil",
      "nav.login": "Entrar",
      "nav.register": "Registrar",
      "nav.logout": "Sair",
      "hero.title": "Viva uma experiência autêntica",
      "hero.subtitle": "Deixe-se guiar por locais apaixonados para descobrir lugares escondidos",
      "hero.cta": "Começar a aventura",
      "hero.search_placeholder": "Para onde você quer ir?",
      "home.categories": "Explorar por categoria",
      "home.featured": "Experiências populares",
      "home.explorers": "Nossos exploradores",
      "home.how_it_works": "Como funciona",
      "home.step1_title": "Escolha seu destino",
      "home.step1_desc": "Navegue por nossas experiências únicas ao redor do mundo",
      "home.step2_title": "Conecte-se com um explorador",
      "home.step2_desc": "Converse com um local apaixonado que conhece sua região",
      "home.step3_title": "Viva a aventura",
      "home.step3_desc": "Deixe-se guiar e crie memórias inesquecíveis",
      "category.adventure": "Aventura e Natureza",
      "category.fun": "Diversão",
      "category.food": "Gastronomia",
      "category.culture": "Cultura e História",
      "category.sport": "Esportes",
      "category.healing": "Bem-estar e Retiro",
      "category.nightlife": "Vida noturna",
      "category.vanlife": "Vanlife",
      "category.artisanat": "Artesanato",
      "category.local_events": "Eventos locais",
      "auth.login_title": "Bem-vindo de volta",
      "auth.login_subtitle": "Entre para continuar sua aventura",
      "auth.register_title": "Junte-se ao XPerience",
      "auth.register_subtitle": "Crie sua conta e comece a aventura",
      "auth.email": "E-mail",
      "auth.password": "Senha",
      "auth.name": "Nome completo",
      "auth.role": "Eu sou...",
      "auth.role_explorer": "Explorador (guia local)",
      "auth.role_experimenter": "Experimentador (viajante)",
      "auth.login_btn": "Entrar",
      "auth.register_btn": "Criar conta",
      "auth.or": "ou",
      "auth.google": "Continuar com Google",
      "auth.no_account": "Não tem uma conta?",
      "auth.has_account": "Já tem uma conta?",
      "exp.from": "A partir de",
      "exp.per_person": "/ pessoa",
      "exp.duration": "Duração",
      "exp.hours": "horas",
      "exp.participants": "Máx. participantes",
      "exp.includes_vehicle": "Veículo incluído",
      "exp.includes_accommodation": "Alojamento incluído",
      "exp.book_now": "Reservar agora",
      "exp.reviews": "avaliações",
      "exp.about_explorer": "Sobre o explorador",
      "exp.select_date": "Selecione uma data",
      "exp.select_participants": "Número de participantes",
      "exp.add_vehicle": "Adicionar veículo",
      "exp.add_accommodation": "Adicionar alojamento",
      "exp.total": "Total",
      "exp.message": "Mensagem para o explorador (opcional)",
      "booking.title": "Reserva",
      "booking.summary": "Resumo",
      "booking.base_price": "Preço base",
      "booking.vehicle": "Veículo",
      "booking.accommodation": "Alojamento",
      "booking.platform_fee": "Taxa de serviço",
      "booking.total": "Total a pagar",
      "booking.pay": "Pagar agora",
      "booking.status.pending": "Pendente",
      "booking.status.confirmed": "Confirmada",
      "booking.status.completed": "Concluída",
      "booking.status.cancelled": "Cancelada",
      "dashboard.title": "Painel de controle",
      "dashboard.my_experiences": "Minhas experiências",
      "dashboard.my_bookings": "Minhas reservas",
      "dashboard.my_reviews": "Minhas avaliações",
      "dashboard.create_experience": "Criar experiência",
      "dashboard.earnings": "Ganhos",
      "dashboard.total_bookings": "Reservas",
      "dashboard.rating": "Avaliação média",
      "dashboard.trips": "Viagens concluídas",
      "common.search": "Pesquisar",
      "common.filter": "Filtrar",
      "common.sort": "Ordenar",
      "common.loading": "Carregando...",
      "common.error": "Ocorreu um erro",
      "common.save": "Salvar",
      "common.cancel": "Cancelar",
      "common.confirm": "Confirmar",
      "common.delete": "Excluir",
      "common.edit": "Editar",
      "common.view": "Ver",
      "common.back": "Voltar",
      "common.next": "Próximo",
      "common.previous": "Anterior",
      "common.success": "Sucesso",
      "footer.tagline": "Viaje diferente, encontre de verdade.",
      "footer.company": "Empresa",
      "footer.about": "Sobre nós",
      "footer.careers": "Carreiras",
      "footer.press": "Imprensa",
      "footer.support": "Suporte",
      "footer.help": "Central de ajuda",
      "footer.contact": "Contato",
      "footer.terms": "Termos",
      "footer.privacy": "Privacidade",
      "footer.legal": "Legal",
      "footer.copyright": "© 2026 XPerience. Todos os direitos reservados.",
      "footer.creator": "Criado por Steve Rosset"
    }
  },
  nl: {
    translation: {
      // Navigation
      "nav.home": "Home",
      "nav.explore": "Ontdekken",
      "nav.dashboard": "Dashboard",
      "nav.profile": "Profiel",
      "nav.login": "Inloggen",
      "nav.register": "Registreren",
      "nav.logout": "Uitloggen",
      
      // Hero
      "hero.title": "Beleef een authentieke ervaring",
      "hero.subtitle": "Laat je leiden door gepassioneerde locals om onontdekte plekken te ontdekken",
      "hero.cta": "Begin het avontuur",
      "hero.search_placeholder": "Waar wil je naartoe?",
      
      // Home
      "home.categories": "Ontdek per categorie",
      "home.featured": "Populaire ervaringen",
      "home.explorers": "Onze ontdekkers",
      "home.how_it_works": "Hoe het werkt",
      "home.step1_title": "Kies je bestemming",
      "home.step1_desc": "Blader door onze unieke ervaringen wereldwijd",
      "home.step2_title": "Verbind met een ontdekker",
      "home.step2_desc": "Chat met een gepassioneerde local die zijn regio kent",
      "home.step3_title": "Beleef het avontuur",
      "home.step3_desc": "Laat je leiden en creëer onvergetelijke herinneringen",
      
      // Categories
      "category.adventure": "Avontuur & Natuur",
      "category.fun": "Fun",
      "category.food": "Gastronomie",
      "category.culture": "Cultuur & Geschiedenis",
      "category.sport": "Sport",
      "category.healing": "Healing & Retraite",
      "category.nightlife": "Nachtleven",
      "category.vanlife": "Vanlife",
      "category.artisanat": "Ambacht",
      "category.local_events": "Lokale evenementen",
      
      // Auth
      "auth.login_title": "Welkom terug",
      "auth.login_subtitle": "Log in om je avontuur voort te zetten",
      "auth.register_title": "Word lid van XPerience",
      "auth.register_subtitle": "Maak je account aan en begin het avontuur",
      "auth.email": "E-mail",
      "auth.password": "Wachtwoord",
      "auth.name": "Volledige naam",
      "auth.role": "Ik ben...",
      "auth.role_explorer": "Ontdekker (lokale gids)",
      "auth.role_experimenter": "Reiziger",
      "auth.login_btn": "Inloggen",
      "auth.register_btn": "Account aanmaken",
      "auth.or": "of",
      "auth.google": "Doorgaan met Google",
      "auth.no_account": "Nog geen account?",
      "auth.has_account": "Heb je al een account?",
      
      // Experience
      "exp.from": "Vanaf",
      "exp.per_person": "/ persoon",
      "exp.duration": "Duur",
      "exp.hours": "uur",
      "exp.participants": "Max deelnemers",
      "exp.includes_vehicle": "Voertuig inbegrepen",
      "exp.includes_accommodation": "Accommodatie inbegrepen",
      "exp.book_now": "Reserveren",
      "exp.reviews": "beoordelingen",
      "exp.about_explorer": "Over de ontdekker",
      "exp.select_date": "Selecteer een datum",
      "exp.select_participants": "Aantal deelnemers",
      "exp.add_vehicle": "Voertuig toevoegen",
      "exp.add_accommodation": "Accommodatie toevoegen",
      "exp.total": "Totaal",
      "exp.message": "Bericht voor de ontdekker (optioneel)",
      
      // Booking
      "booking.title": "Reservering",
      "booking.summary": "Samenvatting",
      "booking.base_price": "Basisprijs",
      "booking.vehicle": "Voertuig",
      "booking.accommodation": "Accommodatie",
      "booking.platform_fee": "Servicekosten",
      "booking.total": "Totaal te betalen",
      "booking.pay": "Nu betalen",
      "booking.status.pending": "In behandeling",
      "booking.status.confirmed": "Bevestigd",
      "booking.status.completed": "Voltooid",
      "booking.status.cancelled": "Geannuleerd",
      
      // Dashboard
      "dashboard.title": "Dashboard",
      "dashboard.my_experiences": "Mijn ervaringen",
      "dashboard.my_bookings": "Mijn reserveringen",
      "dashboard.my_reviews": "Mijn beoordelingen",
      "dashboard.create_experience": "Ervaring aanmaken",
      "dashboard.earnings": "Inkomsten",
      "dashboard.total_bookings": "Reserveringen",
      "dashboard.rating": "Gemiddelde score",
      "dashboard.trips": "Voltooide reizen",
      
      // Common
      "common.search": "Zoeken",
      "common.filter": "Filteren",
      "common.sort": "Sorteren",
      "common.loading": "Laden...",
      "common.error": "Er is een fout opgetreden",
      "common.save": "Opslaan",
      "common.cancel": "Annuleren",
      "common.confirm": "Bevestigen",
      "common.delete": "Verwijderen",
      "common.edit": "Bewerken",
      "common.view": "Bekijken",
      "common.back": "Terug",
      "common.next": "Volgende",
      "common.previous": "Vorige",
      "common.success": "Succes",
      
      // Footer
      "footer.tagline": "Reis anders, ontmoet echt.",
      "footer.company": "Bedrijf",
      "footer.about": "Over ons",
      "footer.careers": "Carrières",
      "footer.press": "Pers",
      "footer.support": "Ondersteuning",
      "footer.help": "Helpcentrum",
      "footer.contact": "Contact",
      "footer.terms": "Voorwaarden",
      "footer.privacy": "Privacy",
      "footer.legal": "Juridisch",
      "footer.copyright": "© 2026 XPerience. Alle rechten voorbehouden.",
      "footer.creator": "Gemaakt door Steve Rosset"
    }
  },
  ru: {
    translation: {
      // Navigation
      "nav.home": "Главная",
      "nav.explore": "Исследовать",
      "nav.dashboard": "Панель",
      "nav.profile": "Профиль",
      "nav.login": "Вход",
      "nav.register": "Регистрация",
      "nav.logout": "Выход",
      
      // Hero
      "hero.title": "Живите подлинным опытом",
      "hero.subtitle": "Позвольте местным жителям показать вам скрытые места",
      "hero.cta": "Начать приключение",
      "hero.search_placeholder": "Куда вы хотите поехать?",
      
      // Home
      "home.categories": "Исследуйте по категориям",
      "home.featured": "Популярные впечатления",
      "home.explorers": "Наши гиды",
      "home.how_it_works": "Как это работает",
      "home.step1_title": "Выберите направление",
      "home.step1_desc": "Просматривайте уникальные впечатления по всему миру",
      "home.step2_title": "Свяжитесь с гидом",
      "home.step2_desc": "Общайтесь с местным жителем, который знает свой регион",
      "home.step3_title": "Проживите приключение",
      "home.step3_desc": "Позвольте себе быть ведомым и создайте незабываемые воспоминания",
      
      // Categories
      "category.adventure": "Приключения и природа",
      "category.fun": "Развлечения",
      "category.food": "Гастрономия",
      "category.culture": "Культура и история",
      "category.sport": "Спорт",
      "category.healing": "Оздоровление",
      "category.nightlife": "Ночная жизнь",
      "category.vanlife": "Vanlife",
      "category.artisanat": "Ремёсла",
      "category.local_events": "Местные события",
      
      // Auth
      "auth.login_title": "Добро пожаловать",
      "auth.login_subtitle": "Войдите, чтобы продолжить приключение",
      "auth.register_title": "Присоединяйтесь к XPerience",
      "auth.register_subtitle": "Создайте аккаунт и начните приключение",
      "auth.email": "Email",
      "auth.password": "Пароль",
      "auth.name": "Полное имя",
      "auth.role": "Я...",
      "auth.role_explorer": "Гид (местный житель)",
      "auth.role_experimenter": "Путешественник",
      "auth.login_btn": "Войти",
      "auth.register_btn": "Создать аккаунт",
      "auth.or": "или",
      "auth.google": "Продолжить с Google",
      "auth.no_account": "Ещё нет аккаунта?",
      "auth.has_account": "Уже есть аккаунт?",
      
      // Experience
      "exp.from": "От",
      "exp.per_person": "/ человек",
      "exp.duration": "Длительность",
      "exp.hours": "часов",
      "exp.participants": "Макс. участников",
      "exp.includes_vehicle": "Транспорт включён",
      "exp.includes_accommodation": "Проживание включено",
      "exp.book_now": "Забронировать",
      "exp.reviews": "отзывов",
      "exp.about_explorer": "О гиде",
      "exp.select_date": "Выберите дату",
      "exp.select_participants": "Количество участников",
      "exp.add_vehicle": "Добавить транспорт",
      "exp.add_accommodation": "Добавить проживание",
      "exp.total": "Итого",
      "exp.message": "Сообщение для гида (необязательно)",
      
      // Booking
      "booking.title": "Бронирование",
      "booking.summary": "Итог",
      "booking.base_price": "Базовая цена",
      "booking.vehicle": "Транспорт",
      "booking.accommodation": "Проживание",
      "booking.platform_fee": "Сервисный сбор",
      "booking.total": "К оплате",
      "booking.pay": "Оплатить",
      "booking.status.pending": "Ожидание",
      "booking.status.confirmed": "Подтверждено",
      "booking.status.completed": "Завершено",
      "booking.status.cancelled": "Отменено",
      
      // Dashboard
      "dashboard.title": "Панель управления",
      "dashboard.my_experiences": "Мои впечатления",
      "dashboard.my_bookings": "Мои бронирования",
      "dashboard.my_reviews": "Мои отзывы",
      "dashboard.create_experience": "Создать впечатление",
      "dashboard.earnings": "Доходы",
      "dashboard.total_bookings": "Бронирования",
      "dashboard.rating": "Средний рейтинг",
      "dashboard.trips": "Поездки",
      
      // Common
      "common.search": "Поиск",
      "common.filter": "Фильтр",
      "common.sort": "Сортировка",
      "common.loading": "Загрузка...",
      "common.error": "Произошла ошибка",
      "common.save": "Сохранить",
      "common.cancel": "Отмена",
      "common.confirm": "Подтвердить",
      "common.delete": "Удалить",
      "common.edit": "Редактировать",
      "common.view": "Просмотр",
      "common.back": "Назад",
      "common.next": "Далее",
      "common.previous": "Предыдущий",
      "common.success": "Успех",
      
      // Footer
      "footer.tagline": "Путешествуйте иначе, встречайтесь по-настоящему.",
      "footer.company": "Компания",
      "footer.about": "О нас",
      "footer.careers": "Карьера",
      "footer.press": "Пресса",
      "footer.support": "Поддержка",
      "footer.help": "Центр помощи",
      "footer.contact": "Контакты",
      "footer.terms": "Условия",
      "footer.privacy": "Конфиденциальность",
      "footer.legal": "Правовая информация",
      "footer.copyright": "© 2026 XPerience. Все права защищены.",
      "footer.creator": "Создано Steve Rosset"
    }
  },
  ja: {
    translation: {
      // Navigation
      "nav.home": "ホーム",
      "nav.explore": "探索",
      "nav.dashboard": "ダッシュボード",
      "nav.profile": "プロフィール",
      "nav.login": "ログイン",
      "nav.register": "登録",
      "nav.logout": "ログアウト",
      
      // Hero
      "hero.title": "本物の体験を",
      "hero.subtitle": "情熱的な地元の人々に隠れた場所を案内してもらいましょう",
      "hero.cta": "冒険を始める",
      "hero.search_placeholder": "どこに行きたいですか？",
      
      // Home
      "home.categories": "カテゴリーで探す",
      "home.featured": "人気の体験",
      "home.explorers": "私たちのガイド",
      "home.how_it_works": "使い方",
      "home.step1_title": "目的地を選ぶ",
      "home.step1_desc": "世界中のユニークな体験を閲覧",
      "home.step2_title": "ガイドとつながる",
      "home.step2_desc": "地元を知り尽くした人とチャット",
      "home.step3_title": "冒険を体験",
      "home.step3_desc": "案内を受けて忘れられない思い出を作る",
      
      // Categories
      "category.adventure": "アドベンチャー＆自然",
      "category.fun": "楽しい",
      "category.food": "グルメ",
      "category.culture": "文化と歴史",
      "category.sport": "スポーツ",
      "category.healing": "ヒーリング",
      "category.nightlife": "ナイトライフ",
      "category.vanlife": "バンライフ",
      "category.artisanat": "工芸",
      "category.local_events": "地元のイベント",
      
      // Auth
      "auth.login_title": "おかえりなさい",
      "auth.login_subtitle": "ログインして冒険を続けましょう",
      "auth.register_title": "XPerience に参加",
      "auth.register_subtitle": "アカウントを作成して冒険を始めましょう",
      "auth.email": "メール",
      "auth.password": "パスワード",
      "auth.name": "氏名",
      "auth.role": "私は...",
      "auth.role_explorer": "ガイド（地元の人）",
      "auth.role_experimenter": "旅行者",
      "auth.login_btn": "ログイン",
      "auth.register_btn": "アカウント作成",
      "auth.or": "または",
      "auth.google": "Google で続ける",
      "auth.no_account": "アカウントをお持ちでないですか？",
      "auth.has_account": "すでにアカウントをお持ちですか？",
      
      // Experience
      "exp.from": "から",
      "exp.per_person": "/ 人",
      "exp.duration": "所要時間",
      "exp.hours": "時間",
      "exp.participants": "最大参加者数",
      "exp.includes_vehicle": "車両込み",
      "exp.includes_accommodation": "宿泊込み",
      "exp.book_now": "予約する",
      "exp.reviews": "レビュー",
      "exp.about_explorer": "ガイドについて",
      "exp.select_date": "日付を選択",
      "exp.select_participants": "参加者数",
      "exp.add_vehicle": "車両を追加",
      "exp.add_accommodation": "宿泊を追加",
      "exp.total": "合計",
      "exp.message": "ガイドへのメッセージ（任意）",
      
      // Booking
      "booking.title": "予約",
      "booking.summary": "概要",
      "booking.base_price": "基本料金",
      "booking.vehicle": "車両",
      "booking.accommodation": "宿泊",
      "booking.platform_fee": "サービス料",
      "booking.total": "合計金額",
      "booking.pay": "今すぐ支払う",
      "booking.status.pending": "保留中",
      "booking.status.confirmed": "確認済み",
      "booking.status.completed": "完了",
      "booking.status.cancelled": "キャンセル",
      
      // Dashboard
      "dashboard.title": "ダッシュボード",
      "dashboard.my_experiences": "私の体験",
      "dashboard.my_bookings": "私の予約",
      "dashboard.my_reviews": "私のレビュー",
      "dashboard.create_experience": "体験を作成",
      "dashboard.earnings": "収益",
      "dashboard.total_bookings": "予約数",
      "dashboard.rating": "平均評価",
      "dashboard.trips": "旅行数",
      
      // Common
      "common.search": "検索",
      "common.filter": "フィルター",
      "common.sort": "並べ替え",
      "common.loading": "読み込み中...",
      "common.error": "エラーが発生しました",
      "common.save": "保存",
      "common.cancel": "キャンセル",
      "common.confirm": "確認",
      "common.delete": "削除",
      "common.edit": "編集",
      "common.view": "表示",
      "common.back": "戻る",
      "common.next": "次へ",
      "common.previous": "前へ",
      "common.success": "成功",
      
      // Footer
      "footer.tagline": "違う旅を、本物の出会いを。",
      "footer.company": "会社",
      "footer.about": "私たちについて",
      "footer.careers": "採用情報",
      "footer.press": "プレス",
      "footer.support": "サポート",
      "footer.help": "ヘルプセンター",
      "footer.contact": "お問い合わせ",
      "footer.terms": "利用規約",
      "footer.privacy": "プライバシー",
      "footer.legal": "法的情報",
      "footer.copyright": "© 2026 XPerience. All rights reserved.",
      "footer.creator": "Created by Steve Rosset"
    }
  },
  zh: {
    translation: {
      // Navigation
      "nav.home": "首页",
      "nav.explore": "探索",
      "nav.dashboard": "仪表板",
      "nav.profile": "个人资料",
      "nav.login": "登录",
      "nav.register": "注册",
      "nav.logout": "退出",
      
      // Hero
      "hero.title": "体验真实的旅行",
      "hero.subtitle": "让当地人带您发现隐藏的宝藏",
      "hero.cta": "开始冒险",
      "hero.search_placeholder": "您想去哪里？",
      
      // Home
      "home.categories": "按类别探索",
      "home.featured": "热门体验",
      "home.explorers": "我们的向导",
      "home.how_it_works": "如何运作",
      "home.step1_title": "选择目的地",
      "home.step1_desc": "浏览世界各地的独特体验",
      "home.step2_title": "联系向导",
      "home.step2_desc": "与了解当地的本地人聊天",
      "home.step3_title": "享受冒险",
      "home.step3_desc": "让自己被引导，创造难忘的回忆",
      
      // Categories
      "category.adventure": "冒险与自然",
      "category.fun": "有趣",
      "category.food": "美食",
      "category.culture": "文化与历史",
      "category.sport": "运动",
      "category.healing": "养生",
      "category.nightlife": "夜生活",
      "category.vanlife": "房车生活",
      "category.artisanat": "手工艺",
      "category.local_events": "当地活动",
      
      // Auth
      "auth.login_title": "欢迎回来",
      "auth.login_subtitle": "登录继续您的冒险",
      "auth.register_title": "加入 XPerience",
      "auth.register_subtitle": "创建账户开始冒险",
      "auth.email": "邮箱",
      "auth.password": "密码",
      "auth.name": "全名",
      "auth.role": "我是...",
      "auth.role_explorer": "向导（当地人）",
      "auth.role_experimenter": "旅行者",
      "auth.login_btn": "登录",
      "auth.register_btn": "创建账户",
      "auth.or": "或",
      "auth.google": "使用 Google 继续",
      "auth.no_account": "还没有账户？",
      "auth.has_account": "已有账户？",
      
      // Experience
      "exp.from": "起价",
      "exp.per_person": "/ 人",
      "exp.duration": "时长",
      "exp.hours": "小时",
      "exp.participants": "最多参与者",
      "exp.includes_vehicle": "含车辆",
      "exp.includes_accommodation": "含住宿",
      "exp.book_now": "立即预订",
      "exp.reviews": "评价",
      "exp.about_explorer": "关于向导",
      "exp.select_date": "选择日期",
      "exp.select_participants": "参与人数",
      "exp.add_vehicle": "添加车辆",
      "exp.add_accommodation": "添加住宿",
      "exp.total": "总计",
      "exp.message": "给向导的留言（可选）",
      
      // Booking
      "booking.title": "预订",
      "booking.summary": "摘要",
      "booking.base_price": "基本价格",
      "booking.vehicle": "车辆",
      "booking.accommodation": "住宿",
      "booking.platform_fee": "服务费",
      "booking.total": "应付总额",
      "booking.pay": "立即支付",
      "booking.status.pending": "待处理",
      "booking.status.confirmed": "已确认",
      "booking.status.completed": "已完成",
      "booking.status.cancelled": "已取消",
      
      // Dashboard
      "dashboard.title": "仪表板",
      "dashboard.my_experiences": "我的体验",
      "dashboard.my_bookings": "我的预订",
      "dashboard.my_reviews": "我的评价",
      "dashboard.create_experience": "创建体验",
      "dashboard.earnings": "收入",
      "dashboard.total_bookings": "预订数",
      "dashboard.rating": "平均评分",
      "dashboard.trips": "旅行次数",
      
      // Common
      "common.search": "搜索",
      "common.filter": "筛选",
      "common.sort": "排序",
      "common.loading": "加载中...",
      "common.error": "发生错误",
      "common.save": "保存",
      "common.cancel": "取消",
      "common.confirm": "确认",
      "common.delete": "删除",
      "common.edit": "编辑",
      "common.view": "查看",
      "common.back": "返回",
      "common.next": "下一步",
      "common.previous": "上一步",
      "common.success": "成功",
      
      // Footer
      "footer.tagline": "不一样的旅行，真实的相遇。",
      "footer.company": "公司",
      "footer.about": "关于我们",
      "footer.careers": "招聘",
      "footer.press": "新闻",
      "footer.support": "支持",
      "footer.help": "帮助中心",
      "footer.contact": "联系我们",
      "footer.terms": "条款",
      "footer.privacy": "隐私",
      "footer.legal": "法律",
      "footer.copyright": "© 2026 XPerience. 保留所有权利。",
      "footer.creator": "由 Steve Rosset 创建"
    }
  },
  pl: {
    translation: {
      // Navigation
      "nav.home": "Strona główna",
      "nav.explore": "Odkrywaj",
      "nav.dashboard": "Panel",
      "nav.profile": "Profil",
      "nav.login": "Zaloguj",
      "nav.register": "Zarejestruj",
      "nav.logout": "Wyloguj",
      
      // Hero
      "hero.title": "Przeżyj autentyczne doświadczenie",
      "hero.subtitle": "Pozwól lokalnym pasjonatom pokazać Ci ukryte miejsca",
      "hero.cta": "Rozpocznij przygodę",
      "hero.search_placeholder": "Dokąd chcesz jechać?",
      
      // Home
      "home.categories": "Przeglądaj według kategorii",
      "home.featured": "Popularne doświadczenia",
      "home.explorers": "Nasi przewodnicy",
      "home.how_it_works": "Jak to działa",
      "home.step1_title": "Wybierz cel podróży",
      "home.step1_desc": "Przeglądaj unikalne doświadczenia na całym świecie",
      "home.step2_title": "Połącz się z przewodnikiem",
      "home.step2_desc": "Porozmawiaj z lokalnym mieszkańcem znającym swój region",
      "home.step3_title": "Przeżyj przygodę",
      "home.step3_desc": "Daj się poprowadzić i stwórz niezapomniane wspomnienia",
      
      // Categories
      "category.adventure": "Przygoda i natura",
      "category.fun": "Zabawa",
      "category.food": "Gastronomia",
      "category.culture": "Kultura i historia",
      "category.sport": "Sport",
      "category.healing": "Odnowa",
      "category.nightlife": "Życie nocne",
      "category.vanlife": "Vanlife",
      "category.artisanat": "Rękodzieło",
      "category.local_events": "Lokalne wydarzenia",
      
      // Auth
      "auth.login_title": "Witaj ponownie",
      "auth.login_subtitle": "Zaloguj się, aby kontynuować przygodę",
      "auth.register_title": "Dołącz do XPerience",
      "auth.register_subtitle": "Utwórz konto i rozpocznij przygodę",
      "auth.email": "Email",
      "auth.password": "Hasło",
      "auth.name": "Imię i nazwisko",
      "auth.role": "Jestem...",
      "auth.role_explorer": "Przewodnikiem (lokalny)",
      "auth.role_experimenter": "Podróżnikiem",
      "auth.login_btn": "Zaloguj",
      "auth.register_btn": "Utwórz konto",
      "auth.or": "lub",
      "auth.google": "Kontynuuj z Google",
      "auth.no_account": "Nie masz jeszcze konta?",
      "auth.has_account": "Masz już konto?",
      
      // Experience
      "exp.from": "Od",
      "exp.per_person": "/ osoba",
      "exp.duration": "Czas trwania",
      "exp.hours": "godzin",
      "exp.participants": "Maks. uczestników",
      "exp.includes_vehicle": "Pojazd w cenie",
      "exp.includes_accommodation": "Nocleg w cenie",
      "exp.book_now": "Zarezerwuj",
      "exp.reviews": "opinii",
      "exp.about_explorer": "O przewodniku",
      "exp.select_date": "Wybierz datę",
      "exp.select_participants": "Liczba uczestników",
      "exp.add_vehicle": "Dodaj pojazd",
      "exp.add_accommodation": "Dodaj nocleg",
      "exp.total": "Suma",
      "exp.message": "Wiadomość do przewodnika (opcjonalnie)",
      
      // Booking
      "booking.title": "Rezerwacja",
      "booking.summary": "Podsumowanie",
      "booking.base_price": "Cena podstawowa",
      "booking.vehicle": "Pojazd",
      "booking.accommodation": "Nocleg",
      "booking.platform_fee": "Opłata serwisowa",
      "booking.total": "Do zapłaty",
      "booking.pay": "Zapłać teraz",
      "booking.status.pending": "Oczekuje",
      "booking.status.confirmed": "Potwierdzona",
      "booking.status.completed": "Zakończona",
      "booking.status.cancelled": "Anulowana",
      
      // Dashboard
      "dashboard.title": "Panel",
      "dashboard.my_experiences": "Moje doświadczenia",
      "dashboard.my_bookings": "Moje rezerwacje",
      "dashboard.my_reviews": "Moje opinie",
      "dashboard.create_experience": "Utwórz doświadczenie",
      "dashboard.earnings": "Zarobki",
      "dashboard.total_bookings": "Rezerwacje",
      "dashboard.rating": "Średnia ocena",
      "dashboard.trips": "Podróże",
      
      // Common
      "common.search": "Szukaj",
      "common.filter": "Filtruj",
      "common.sort": "Sortuj",
      "common.loading": "Ładowanie...",
      "common.error": "Wystąpił błąd",
      "common.save": "Zapisz",
      "common.cancel": "Anuluj",
      "common.confirm": "Potwierdź",
      "common.delete": "Usuń",
      "common.edit": "Edytuj",
      "common.view": "Zobacz",
      "common.back": "Wróć",
      "common.next": "Dalej",
      "common.previous": "Poprzedni",
      "common.success": "Sukces",
      
      // Footer
      "footer.tagline": "Podróżuj inaczej, spotykaj naprawdę.",
      "footer.company": "Firma",
      "footer.about": "O nas",
      "footer.careers": "Kariera",
      "footer.press": "Prasa",
      "footer.support": "Wsparcie",
      "footer.help": "Centrum pomocy",
      "footer.contact": "Kontakt",
      "footer.terms": "Regulamin",
      "footer.privacy": "Prywatność",
      "footer.legal": "Prawne",
      "footer.copyright": "© 2026 XPerience. Wszelkie prawa zastrzeżone.",
      "footer.creator": "Stworzone przez Steve Rosset"
    }
  },
  ar: {
    translation: {
      // Navigation
      "nav.home": "الرئيسية",
      "nav.explore": "استكشف",
      "nav.dashboard": "لوحة التحكم",
      "nav.profile": "الملف الشخصي",
      "nav.login": "تسجيل الدخول",
      "nav.register": "التسجيل",
      "nav.logout": "تسجيل الخروج",
      
      // Hero
      "hero.title": "عش تجربة أصيلة",
      "hero.subtitle": "دع السكان المحليين المتحمسين يرشدونك إلى الأماكن المخفية",
      "hero.cta": "ابدأ المغامرة",
      "hero.search_placeholder": "إلى أين تريد الذهاب؟",
      
      // Home
      "home.categories": "استكشف حسب الفئة",
      "home.featured": "التجارب الشائعة",
      "home.explorers": "مرشدونا",
      "home.how_it_works": "كيف يعمل",
      "home.step1_title": "اختر وجهتك",
      "home.step1_desc": "تصفح التجارب الفريدة حول العالم",
      "home.step2_title": "تواصل مع مرشد",
      "home.step2_desc": "تحدث مع شخص محلي يعرف منطقته",
      "home.step3_title": "عش المغامرة",
      "home.step3_desc": "دع نفسك تُرشد واصنع ذكريات لا تُنسى",
      
      // Categories
      "category.adventure": "مغامرة وطبيعة",
      "category.fun": "متعة",
      "category.food": "طعام",
      "category.culture": "ثقافة وتاريخ",
      "category.sport": "رياضة",
      "category.healing": "استشفاء",
      "category.nightlife": "حياة ليلية",
      "category.vanlife": "حياة الفان",
      "category.artisanat": "حرف يدوية",
      "category.local_events": "فعاليات محلية",
      
      // Auth
      "auth.login_title": "مرحباً بعودتك",
      "auth.login_subtitle": "سجل الدخول لمتابعة مغامرتك",
      "auth.register_title": "انضم إلى XPerience",
      "auth.register_subtitle": "أنشئ حسابك وابدأ المغامرة",
      "auth.email": "البريد الإلكتروني",
      "auth.password": "كلمة المرور",
      "auth.name": "الاسم الكامل",
      "auth.role": "أنا...",
      "auth.role_explorer": "مرشد (محلي)",
      "auth.role_experimenter": "مسافر",
      "auth.login_btn": "تسجيل الدخول",
      "auth.register_btn": "إنشاء حساب",
      "auth.or": "أو",
      "auth.google": "المتابعة مع Google",
      "auth.no_account": "ليس لديك حساب؟",
      "auth.has_account": "لديك حساب بالفعل؟",
      
      // Experience
      "exp.from": "من",
      "exp.per_person": "/ شخص",
      "exp.duration": "المدة",
      "exp.hours": "ساعات",
      "exp.participants": "الحد الأقصى للمشاركين",
      "exp.includes_vehicle": "يشمل السيارة",
      "exp.includes_accommodation": "يشمل الإقامة",
      "exp.book_now": "احجز الآن",
      "exp.reviews": "تقييمات",
      "exp.about_explorer": "عن المرشد",
      "exp.select_date": "اختر التاريخ",
      "exp.select_participants": "عدد المشاركين",
      "exp.add_vehicle": "إضافة سيارة",
      "exp.add_accommodation": "إضافة إقامة",
      "exp.total": "المجموع",
      "exp.message": "رسالة للمرشد (اختياري)",
      
      // Booking
      "booking.title": "الحجز",
      "booking.summary": "الملخص",
      "booking.base_price": "السعر الأساسي",
      "booking.vehicle": "السيارة",
      "booking.accommodation": "الإقامة",
      "booking.platform_fee": "رسوم الخدمة",
      "booking.total": "المبلغ الإجمالي",
      "booking.pay": "ادفع الآن",
      "booking.status.pending": "قيد الانتظار",
      "booking.status.confirmed": "مؤكد",
      "booking.status.completed": "مكتمل",
      "booking.status.cancelled": "ملغى",
      
      // Dashboard
      "dashboard.title": "لوحة التحكم",
      "dashboard.my_experiences": "تجاربي",
      "dashboard.my_bookings": "حجوزاتي",
      "dashboard.my_reviews": "تقييماتي",
      "dashboard.create_experience": "إنشاء تجربة",
      "dashboard.earnings": "الأرباح",
      "dashboard.total_bookings": "الحجوزات",
      "dashboard.rating": "متوسط التقييم",
      "dashboard.trips": "الرحلات",
      
      // Common
      "common.search": "بحث",
      "common.filter": "تصفية",
      "common.sort": "ترتيب",
      "common.loading": "جاري التحميل...",
      "common.error": "حدث خطأ",
      "common.save": "حفظ",
      "common.cancel": "إلغاء",
      "common.confirm": "تأكيد",
      "common.delete": "حذف",
      "common.edit": "تعديل",
      "common.view": "عرض",
      "common.back": "رجوع",
      "common.next": "التالي",
      "common.previous": "السابق",
      "common.success": "نجاح",
      
      // Footer
      "footer.tagline": "سافر بشكل مختلف، التقِ بشكل حقيقي.",
      "footer.company": "الشركة",
      "footer.about": "من نحن",
      "footer.careers": "الوظائف",
      "footer.press": "الصحافة",
      "footer.support": "الدعم",
      "footer.help": "مركز المساعدة",
      "footer.contact": "اتصل بنا",
      "footer.terms": "الشروط",
      "footer.privacy": "الخصوصية",
      "footer.legal": "قانوني",
      "footer.copyright": "© 2026 XPerience. جميع الحقوق محفوظة.",
      "footer.creator": "أنشأه Steve Rosset"
    }
  }
};

// Available languages for the language selector
export const AVAILABLE_LANGUAGES = [
  { code: 'fr', name: 'Français', flag: '🇫🇷' },
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
  { code: 'it', name: 'Italiano', flag: '🇮🇹' },
  { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
  { code: 'pt', name: 'Português', flag: '🇵🇹' },
  { code: 'nl', name: 'Nederlands', flag: '🇳🇱' },
  { code: 'ru', name: 'Русский', flag: '🇷🇺' },
  { code: 'ja', name: '日本語', flag: '🇯🇵' },
  { code: 'zh', name: '中文', flag: '🇨🇳' },
  { code: 'pl', name: 'Polski', flag: '🇵🇱' },
  { code: 'ar', name: 'العربية', flag: '🇸🇦' }
];

// Languages that guides can speak
export const SPOKEN_LANGUAGES = [
  { code: 'fr', name: 'Français' },
  { code: 'en', name: 'English' },
  { code: 'es', name: 'Español' },
  { code: 'it', name: 'Italiano' },
  { code: 'de', name: 'Deutsch' },
  { code: 'pt', name: 'Português' },
  { code: 'nl', name: 'Nederlands' },
  { code: 'ru', name: 'Русский' },
  { code: 'zh', name: '中文' },
  { code: 'ja', name: '日本語' },
  { code: 'ar', name: 'العربية' },
  { code: 'ko', name: '한국어' }
];

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'fr',
    fallbackLng: 'fr',
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
